// Subtle two-note chime via the Web Audio API (no audio asset needed).
// Browsers block audio until a user gesture, so we lazily create a shared
// AudioContext and resume it on the first pointer/keydown interaction.
let ctx = null;
let armed = false;

function getCtx() {
  if (typeof window === "undefined") return null;
  const AC = window.AudioContext || window.webkitAudioContext;
  if (!AC) return null;
  if (!ctx) {
    try { ctx = new AC(); } catch (e) { return null; }
  }
  return ctx;
}

// Call once (e.g. on app/header mount) so the first real user click unlocks audio.
export function armChime() {
  if (armed) return;
  armed = true;
  const resume = () => { const c = getCtx(); if (c && c.state === "suspended") c.resume().catch(() => {}); };
  window.addEventListener("pointerdown", resume, { passive: true });
  window.addEventListener("keydown", resume, { passive: true });
}

// Play a short, gentle ascending two-note chime.
export function playChime() {
  const c = getCtx();
  if (!c) return;
  if (c.state === "suspended") c.resume().catch(() => {});
  const now = c.currentTime;
  [{ f: 880, t: 0 }, { f: 1174.66, t: 0.14 }].forEach(({ f, t }) => {
    const osc = c.createOscillator();
    const gain = c.createGain();
    osc.type = "sine";
    osc.frequency.value = f;
    gain.gain.setValueAtTime(0.0001, now + t);
    gain.gain.exponentialRampToValueAtTime(0.11, now + t + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, now + t + 0.32);
    osc.connect(gain).connect(c.destination);
    osc.start(now + t);
    osc.stop(now + t + 0.36);
  });
}
